import style from './ResetPasswordSuccess.module.css'
import { resetpasswordUpdate } from "../../stores/slices/updatePasswordSlice";  
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Unlock } from 'react-feather';
import { language } from '../../stores/slices/languageSlice';
const ResetPassworSuccess = () => {
  const selectedLanguage = useSelector(language).resetPasswordSuccess;
    let  dispatch= useDispatch()
    let navigate = useNavigate()
    const backtoLogin = () =>{
        dispatch(resetpasswordUpdate())
        navigate('/')
    }
  return <>
   <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className={`${style.basic_page}`}>
              <div>  <Unlock className={style.unlock}/></div>
          <div className="container pt-3">
            <p className={style.success}>
           {selectedLanguage?.passwordResetSuccessful}
            </p>
            <p className="pt-3">
           {selectedLanguage?.content}
            </p>
            <p onClick={backtoLogin} className="pt-3" >
            {selectedLanguage?.please}<u className={`mr-5 ms-1 ${style.reg_link}`}>{selectedLanguage?.ClickHere}</u> {selectedLanguage?.toLogin}
          </p>
          </div>
        </div>
      </div>
  </>;
};

export default ResetPassworSuccess;
